var HITACHI_RAR2P2 = {
  name: "RAR2P2",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [19,2,4,246,1,135,4,248,1,41,1,195,13,83,6,254,1,35,99,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,173,85,223,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,93,250,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_N3",
      fan: "AC_FAN_AUTO",
      command: [19,2,4,248,1,150,4,247,1,51,1,172,13,88,6,7,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,213,85,127,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_N2",
      fan: "AC_FAN_AUTO",
      command: [19,2,4,248,1,147,4,248,1,49,1,172,13,88,6,251,1,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,181,85,191,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_N1",
      fan: "AC_FAN_AUTO",
      command: [19,2,4,247,1,142,4,247,1,45,1,167,13,87,6,4,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,234,170,191,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [19,2,4,246,1,143,4,249,1,50,1,195,13,87,6,7,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,173,85,223,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_1",
      fan: "AC_FAN_AUTO",
      command: [19,2,4,246,1,144,4,248,1,43,1,169,13,87,6,2,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,218,170,223,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_2",
      fan: "AC_FAN_AUTO",
      command: [19,2,4,247,1,140,4,246,1,52,1,188,13,87,6,10,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,186,171,95,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_3",
      fan: "AC_FAN_AUTO",
      command: [19,2,4,249,1,142,4,244,1,50,1,167,13,87,6,3,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,245,85,95,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,213,109,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_N3",
      fan: "AC_FAN_LOW",
      command: [19,2,4,251,1,139,4,249,1,50,1,165,13,88,6,8,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,213,85,127,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,170,183,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_N2",
      fan: "AC_FAN_LOW",
      command: [19,2,4,245,1,141,4,247,1,41,1,175,13,86,6,247,1,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,181,85,191,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,170,183,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_N1",
      fan: "AC_FAN_LOW",
      command: [19,2,4,248,1,142,4,249,1,50,1,172,13,87,6,4,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,234,170,191,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,170,183,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [19,2,4,248,1,143,4,248,1,51,1,171,13,86,6,11,2,0,0,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,173,85,223,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,170,183,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_1",
      fan: "AC_FAN_LOW",
      command: [19,2,4,247,1,141,4,246,1,44,1,167,13,88,6,9,2,35,99,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,218,170,223,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,170,183,213,187,218,170,170,255,170,170,255,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_2",
      fan: "AC_FAN_LOW",
      command: [19,2,4,248,1,141,4,172,13,87,6,248,1,51,1,244,1,35,99,100,146,73,36,153,36,146,73,36,146,73,159,207,252,146,73,36,156,159,39,36,201,147,156,231,38,73,39,60,228,146,100,252,146,73,39,252,146,73,39,252,146,73,39,252,146,73,39,252,146,73,39,255,153,36,147,62,73,156,243,36,146,73,39,252,146,73,39,252,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_AUTO_3",
      fan: "AC_FAN_LOW",
      command: [19,2,4,246,1,143,4,247,1,51,1,165,13,86,6,4,2,35,99,53,85,85,106,170,170,170,173,253,255,170,170,174,190,186,181,174,238,235,85,119,245,85,95,170,170,255,170,170,255,170,170,255,170,170,255,170,170,255,246,170,183,213,187,218,170,170,255,170,170,255,136],
    },
    ]
};

export default HITACHI_RAR2P2
